import styled from 'styled-components';
import UserInitials from '@/trio-ui/UserInitials';

export const CustomUserInitials = styled(UserInitials)`
  margin: 0;
  width: 24px;
  height: 24px;
  font-size: 12px;
`;
